import React from "react";
import { _AboutPetitPrinceRoot } from "./AboutPetitPrince.styled";
import Typography from "../../../../Foundation/Typography/Typography";
import htmlParse from "html-react-parser";
import { lePetitPrinceImages } from "../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import FadeIn from "../../../Animations/FadeIn";

export interface IAboutPetitPrinceProps {
  description?: string;
}

const AboutPetitPrince = (props: IAboutPetitPrinceProps) => {
  const { description } = props;

  return (
    <_AboutPetitPrinceRoot>
      <div className="about-petit-prince__logo">
        <FadeIn delay={0.1}>
          <StyledDiv
            as="img"
            src={lePetitPrinceImages.logoSushiPetitPrince}
            alt="Logo Sushi Petit Prince"
          />
        </FadeIn>
      </div>
      {description && (
        <FadeIn delay={0.2}>
          <Typography
            variant="body"
            className="about-petit-prince__description"
            color="white"
            style={{
              letterSpacing: "-0.17px",
            }}
          >
            {htmlParse(description)}
          </Typography>
        </FadeIn>
      )}
    </_AboutPetitPrinceRoot>
  );
};

export default AboutPetitPrince;
